<app-data-table mainTitle="Tipos de Vínculo"
                singleTitle="Tipo de Vínculo"
                routerPath="/siscoserv/tipo-vinculo"
                entityPath="/tbtipovinc"
                [entity]="tbTipoVinc"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
